import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Member } from '../../../core/models/member/member'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'

export const useOpenFeedbacks = () => {
  const { data, status, load, reload } = useGet<OpenFeedback[]>('feedback/open')

  onMounted(() => {
    load()
  })
  const openFeedbackBus = useEventBus(EventKey.openFeedbackUpdated)
  openFeedbackBus.on(() => reload())

  return { data, status }
}

export interface FeedbackRequest {
  readonly surveyId: string
}
export interface OpenFeedback {
  readonly surveyId: string
  readonly surveyOwnerId: string
  readonly title?: string
  readonly message?: JSON
  readonly updatedAt: string
  readonly createdAt: string
  readonly numberOfQuestions: number
  readonly receiver: Member
  readonly senderState: OpenFeedbackState
  readonly feedbackTopics: ReadonlyArray<{
    id: string
    title: string
    icon?: string
  }>
}

export enum OpenFeedbackState {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Rejected = 'Rejected',
}
